import React, { useCallback, useEffect, useMemo } from 'react';
import { Grid } from '@mui/material';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import SeguimientoFKField from './components/searchFields/SeguimientoFKField';
import NumeroCapaField from './components/searchFields/NumeroCapaField';
export default function TabRevisionCoordinador({
    onChange,
    reclamoFormData,
    editable
}) {
    const handleInputChange = useCallback((fieldName, value) => {
        onChange({
            [fieldName]: value,
        });
    }, []);

    useEffect(() => {
        if (!!reclamoFormData?.stage3?.investigacion && !reclamoFormData?.stage4?.descripcionCierre)
            handleInputChange('descripcionCierre', reclamoFormData?.stage3?.investigacion);
    }, [reclamoFormData?.stage3?.investigacion]);

    const updatedInputs = useMemo(() => {
        return (structuredClone(inputs).map(input => {
            const updatedInput = { ...input };
            switch (input.name) {
                case 'idCapaReclamo':
                    updatedInput.required = !!reclamoFormData?.stage3?.capa;
                    break;

                default:
                    break;
            }
            if (!editable) {
                updatedInput.disabled = true;
            }
            return updatedInput;
        }))
    }, [editable, reclamoFormData?.stage3?.capa]);

    return (
        <div>
            <Grid container spacing={2}>
                {updatedInputs.map(input => (
                    <Grid key={`input-${input.name}-${input.displayName}`} size={{ xs: input.col }}>
                        {input.type !== 'search' && <RenderInputByTypeMobile
                            input={input}
                            handleChange={handleInputChange}
                            value={reclamoFormData?.stage4[input.name]}
                        />}
                        {input.name === 'idSeguimientoFK' && (
                            <SeguimientoFKField
                                onChange={handleInputChange}
                                idSeguimientoFK={reclamoFormData?.stage4?.idSeguimientoFK}
                                disabled={input.disabled}
                            />
                        )}
                        {input.name === 'idCapaReclamo' && (
                            <NumeroCapaField
                                onChange={handleInputChange}
                                idCapaReclamo={reclamoFormData?.stage4?.idCapaReclamo}
                                disabled={input.disabled}
                                idDelegacion={reclamoFormData?.stage1?.idDelegacion}
                            />
                        )}
                    </Grid>
                ))}
            </Grid>
        </div>
    )
}
const inputs = [
    //row
    {
        name: 'idSeguimientoFK',
        displayName: 'SeguimientoFK',
        type: 'search',
        disabled: false,
        col: 3
    },
    {
        name: 'descripcionCierre',
        displayName: 'Descripción de Cierre',
        type: 'long_string',
        disabled: false,
        required: true,
        col: 12
    },
    {
        name: 'correspondeProfesional',
        displayName: 'Corresponde a profesional?',
        type: 'custom_switch',
        required: true,
        disabled: false,
        col: 3
    },
    {
        name: 'idCapaReclamo',
        displayName: 'Nro CAPA',
        type: 'search',
        disabled: false,
        col: 3
    }
]